module.exports = __webpack_public_path__ + "static/media/close.cf61b6d5.png";